import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon, BookOpenIcon, BriefcaseIcon, ClockIcon, SunIcon, ZapIcon, BoxIcon } from "lucide-react";
import { programmePath } from "../../utils/paths";
import { Course, CourseGroupId } from "../../types/content";
interface CourseCardProps {
  course: Course;
}
const groupIcon: Record<CourseGroupId, BoxIcon> = {
  english: BookOpenIcon,
  young: SunIcon,
  professional: BriefcaseIcon,
  short: ZapIcon
};
export function CourseCard({
  course
}: CourseCardProps) {
  const Icon = groupIcon[course.group];
  const length = course.facts[0]?.value;
  return <Link to={programmePath(course.slug)} className="group flex h-full flex-col rounded-[24px] border border-line bg-white p-6 transition-[transform,box-shadow,border-color] duration-200 ease-brand hover:-translate-y-1 hover:border-transparent hover:shadow-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-761" data-mp="122b2va0cbnaz">
      <div className="flex items-start justify-between gap-4" data-id="element-762" data-mp="3ht747ulrbi3i">
        <span className="flex h-11 w-11 items-center justify-center rounded-[13px] bg-cream text-brand" aria-hidden="true" data-id="element-763" data-mp="21yy55ut14lay">
          <Icon className="h-5 w-5" data-id="element-764" data-mp="26w6npwi3arcq" />
        </span>
        <span className="rounded-[10px] bg-mist px-2.5 py-1 type-small font-bold text-body" data-id="element-765" data-mp="1sxq5b8av7cer">
          {course.season === 'seasonal' ? 'Seasonal' : 'Year-round'}
        </span>
      </div>
      <h3 className="mt-6 type-card-title text-ink" data-id="element-766" data-mp="1j7ng7j6v6ilp">{course.name}</h3>
      <p className="mt-1 type-small font-semibold text-muted" data-id="element-767" data-mp="1j5ancazkintv">{course.audience}</p>
      <p className="mt-3 type-card-desc" data-id="element-768" data-mp="1nzom8ndfvd3a">{course.cardText}</p>
      <div className="mt-auto flex items-center justify-between gap-4 border-t border-line pt-5" data-id="element-769" data-mp="1a7i794m0vc5f">
        <span className="inline-flex items-center gap-1.5 type-small font-semibold text-ink" data-id="element-770" data-mp="1e7iwzlekn9rs">
          <ClockIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-771" data-mp="107zrl0d5acj6" />
          {length}
        </span>
        <span className="flex h-10 w-10 items-center justify-center rounded-[13px] bg-brand text-white transition-colors duration-150 group-hover:bg-brand-hover" aria-hidden="true" data-id="element-772" data-mp="157vtmu2a7tw3">
          <ArrowUpRightIcon className="h-5 w-5" data-id="element-773" data-mp="326bju8g72v26" />
        </span>
        <span className="sr-only" data-id="element-774" data-mp="323ysj4ojr8cg">View {course.name}</span>
      </div>
    </Link>;
}